module.exports = __webpack_public_path__ + "static/Ahkio-Black.57beb2d0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Ahkio-Black.woff
// module id = 463
// module chunks = 114276838955818